import React from "react";
import "../../../../App.css";
const SurveyExpired = () => {
  return (
    <div className="underMaintainance-container">
      <div className="maintenceInnerContainer">
        <h2 className="maintenceInnerHeader">Survey</h2>
        <div className="maintenceInnerBody">
          <p>The survey has expired.</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyExpired;
